<template>
  <v-row justify-center>
    <v-dialog :value="value" @input="$emit('input')" max-width="600">
      <v-card>
        <v-card-title class="headline">{{localization.subirImagen}}</v-card-title>
        <v-form v-model="valid" id="valid" ref="form">
          <v-card-text text-xs-center class="text-xs-center">
            <v-flex xs12 pl-3 pr-3>
              <v-file-input :label="localization.añadirFoto" filled
                v-model="picture" id="picture" prepend-icon="photo"
                accept=".jpg, .jpeg, .png"></v-file-input>
              <v-text-field v-model="pictureDescription" id="pictureDescription" 
                :rules="[rules.obligatorio]" :label="localization.descripcion"></v-text-field>
            </v-flex>
          </v-card-text>
        </v-form>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn text @click.native="$emit('input')">{{localization.cancelar}}</v-btn>
          <v-btn color="primary" @click="newImage()" text :disabled="disabled || !picture">{{localization.guardar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  name: 'add-picture',
  props: {
    value: Boolean
  },
  data () {
    return {
      picture: null,
      pictureDescription: '',
      disabled: false,
      valid: true
    }
  },
  computed: {
    localization () {
      console.log("addPictureDialog")
      console.log(this.$t('addPicture'))
      return this.$t('addPicture')
    }
  },
  methods: {
    newImage () {
      this.$store.commit('incidencias/setImagesToUp', {
        picture: this.picture,
        description: this.pictureDescription
      })
      this.picture = null
      this.pictureDescription = ''

      this.$emit('success')

      this.picture = null
      this.pictureDescription = ''

      this.$emit('input')
    }
  }
}
</script>